import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ClickToTextRoutes } from 'pages/clickToText/route/type'
import { ClickToTextPageLayout } from 'pages/clickToText/layout'
import {
  AllClickToText,
  CreateClickToText,
  EditClickToText,
  ViewClickToText,
} from 'pages/clickToText/pages'
import { ClickToTextAccessLayout } from 'pages/clickToText/layout/ClickToTextAccessLayout'

export const ClickToTextRouter = observer(() => (
  <Routes>
    <Route element={<ClickToTextAccessLayout />}>
      <Route element={<ClickToTextPageLayout />}>
        <Route index element={<AllClickToText />} />
        <Route path={`${ClickToTextRoutes.create}`} element={<CreateClickToText />} />
        <Route path={`${ClickToTextRoutes.edit}/:id`} element={<EditClickToText />} />
        <Route
          path={`${ClickToTextRoutes.clone}/:id`}
          element={<EditClickToText isDuplicate={true} />}
        />
        <Route path={`${ClickToTextRoutes.view}/:id`} element={<ViewClickToText />} />
        <Route path={'*'} element={<Navigate to={''} />} />
      </Route>
    </Route>
  </Routes>
))
